const SearchForm = ({ onSubmit, children, ...props }) => {
  const handleKeyDown = e => {
    // Submit form on Enter key when focus is on select elements
    if (e.key === "Enter") {
      const target = e.target;
      // Check if the target is a select-related element (react-select control, Listbox button, etc.)
      const isSelectElement =
        target.closest('[role="combobox"]') ||
        target.closest('[role="listbox"]') ||
        target.closest('[id*="headlessui-listbox-button"]') ||
        target.closest('[id*="react-select"]') ||
        target.classList.contains("css-") ||
        target.tagName === "SELECT";
      
      // Only submit if menu is not open (check for visible menu)
      const isMenuOpen = document.querySelector('[role="listbox"][aria-expanded="true"]') ||
                         document.querySelector('[id*="headlessui-listbox-options"]:not([hidden])') ||
                         document.querySelector('[id*="react-select"]:not([aria-hidden="true"])');
      
      if (isSelectElement && !isMenuOpen) {
        e.preventDefault();
        onSubmit?.(e);
      }
    }
  };

  return (
    <form onSubmit={onSubmit} onKeyDown={handleKeyDown} {...props}>
      {children}
    </form>
  );
};

export { SearchForm };

